import React, { useState, useRef, useEffect } from "react";
import systemListingService from "./SystemListingServices";
import ProductStatusExtUpsert from "./upsert/ProductStatusExtUpsert";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import { CommonUtilities } from "commonUtils";

export default function ProductStatusExt(param: any) {

  let [editingOn, setEditingOn] = useState(false);
  let [deleteData, setDeleteData] = useState<any>([]);
  let [deleteStatus, setDeleteStatus] = useState(false);
  let [openUpsertUX, setOpenUpsertUX] = useState(false);
  let [editDataDawer, seteditDataDawer] = useState<any>([]);
  let [ProductStatusExt, SetProductStatusExt] = useState<any>([]);

  useEffect(() => {
    if (param.activeTab === "Product Status Ext") {
      ProductStatusExtSelect()
    }
  }, [param]);

  const ProductStatusExtSelect = () => {
    var payload = {}
    systemListingService.statusProductExtList(payload).then((res: any) => { SetProductStatusExt(res) });
  }

  const handleMakeDefault = (rowId: number) => { };

  const openAddDrawer = (e: any) => {
    editDataDawer = e
    seteditDataDawer(editDataDawer)
    openUpsertUX = true
    setOpenUpsertUX(openUpsertUX)
  };

  const closeUpsertUX = () => { setOpenUpsertUX(!openUpsertUX) }

  const deleteSelection = (e: any) => {
    console.log(e)
    deleteData = e
    setDeleteData(deleteData)

    deleteStatus = true;
    setDeleteStatus(deleteStatus)
  }

  const deleteConfirmation = (e: any) => {
    console.log(e)

    //e==1 YES
    if (e == 1) {
      systemFormatsList.deletestatusProductExt(deleteData).then((respond: any) => {
        CommonUtilities.showToastDawer('Product Status Ext delete Successfull', 'Success')
      })
    }
    //e==2 NO
    deleteStatus = false;
    setDeleteStatus(deleteStatus)
  }

  const slider_handler = (e: any, selectData: any) => {

    if (e.target.type == "checkbox") {

      selectData[e?.target?.name] = selectData[e?.target?.name] == 1 ? 0 : 1

      systemListingService.saveStatusAccountExt(selectData).then((repond: any) => {
        ProductStatusExtSelect();
      })
    }
  }

  return (
    <div className="content-card ws-12">

      <div className="ptl pbl ws-12">
        <span className="text-bold">Product Status Ext</span>
        <button className="icon-btn info pull-right" type="button" onClick={() => setEditingOn((prev) => !prev)}> {editingOn ? "Edit Mode: On" : "Edit Mode: Off"}</button>

        <div className="ws-12 mt">
          <button className="icon-btn primary height35 pull-right fill" type="button" onClick={() => openAddDrawer({})} disabled={!editingOn}>Add New Product Status Ext</button>
          <button className="btn-save-table hide" type="button" disabled={!editingOn} onClick={() => { setEditingOn(false); }}> Save Changes </button>
        </div>

      </div>

      <div className="ws-12">
        <table className={editingOn ? "editing-on newTable" : "newTable"} >
          <thead>
            <tr>
              <th className="col-useid" style={{ width: "15%" }}>Product Status Ext ID</th>
              <th style={{ width: "30%" }}>Name</th>
              <th className="col-short" style={{ width: "30%" }}>Short Code</th>
              <th style={{ width: "17%" }}>Operations</th>
            </tr>
          </thead>
          <tbody>
            {ProductStatusExt.map((row: any) => (
              <tr key={row.id}>
                <td >{row.productStatusExtUseID}</td>
                <td >

                  <span style={{
                    background: CommonUtilities.lookUpTypeList('statusProductExtName', row.productStatusExtName, 'bgColor'),
                    color: CommonUtilities.lookUpTypeList('statusProductExtName', row.productStatusExtName, 'fontColor'),
                    borderRadius: "4px"
                  }} className="pm forceSingleLine">
                    {row.productStatusExtName}
                  </span>
                </td>
                <td >{row.productStatusExtShortCode}</td>

                <td style={{ pointerEvents: editingOn ? "auto" : "none", opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed", }}>

                  <div className="width225">
                    <button className={`icon-btn info ${row.isDefault ? "fill" : ""}`} type="button" disabled={!editingOn} onClick={() => handleMakeDefault(row.id)}> Default  </button>
                    <button className="icon-btn edit" title="Edit " type="button" disabled={!editingOn} onClick={() => openAddDrawer(row)}><i className="icon-pencil"></i> </button>
                    <button className="icon-btn delete" type="button" disabled={!editingOn} onClick={() => deleteSelection(row)}>  <i className="icon-trash"> </i>  </button>
                  </div>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {
        (() => {
          if (openUpsertUX) {
            return <ProductStatusExtUpsert openUpsertUX={openUpsertUX} closeDrawer={closeUpsertUX} />
          }

          if (deleteStatus) {
            return <DeleteDialogueBox param={deleteStatus} message={"delete the selected product status ext " + deleteData?.productStatusExtName} onChange={deleteConfirmation} />
          }
        })()
      }

    </div>
  );
};